<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<div class="cssLayoutColumnCenterStart">
  <div class="cssLayoutRowStartCenter">
    <div class="sp-icon">
      <mat-icon class="mdi-24px" fontIcon="mdi-monitor-dashboard"
        [ngStyle]="{'color': 'var(--mat-sys-primary)'}"></mat-icon>
    </div>
    <mat-form-field class="collection-box">
      <mat-label>Select a Collection</mat-label>
      <mat-select placeholder="Collection" [value]="selectedCollectionId"
        (selectionChange)="selectCollection($event.value)">
        @for (collection of collectionList; track collection) {
        <mat-option [value]="collection.id">
          {{ collection.name }}
        </mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (selectedCollectionId) {
    <div style="min-width: 370px;">
      <mat-paginator [pageSizeOptions]="[5, 10, 15, 20, 25, 50, 100, 200]" [pageSize]="10"></mat-paginator>
    </div>
    }
  </div>
  <div class="table-container">
    @if (!isLoading && selectedCollectionId) {
    <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>
          <div class="button-cell">
            <button mat-icon-button (click)="addOrEditExhibit(null)" style="outline: none;" title="Add Exhibit"
              [disabled]="isBusy || !canCreate">
              <mat-icon class="mdi-24px center-self" fontIcon="mdi-plus-circle"></mat-icon>
            </button>
            <button mat-icon-button (click)="isBusy = true; jsonInput.click(); $event.stopPropagation()"
              title="Upload Exhibit" [disabled]="isBusy || !canCreate">
              <mat-icon class="mdi-24px center-self" fontIcon="mdi-upload" alt="Upload"></mat-icon>
            </button>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button (click)="addOrEditExhibit(element); $event.stopPropagation()" style="outline: none;"
            title="Edit {{ element.name }}" [disabled]="isBusy || !canEditExhibit(element.id)">
            <mat-icon class="mdi-18px center-self" fontIcon="mdi-square-edit-outline"></mat-icon>
          </button>
          <button mat-icon-button (click)="copyExhibit(element.id); $event.stopPropagation();"
            title="Copy {{ element.name }}" [disabled]="isBusy || !canCreate">
            <mat-icon class="mdi-18px" fontIcon="mdi-content-copy" alt="Copy"></mat-icon>
          </button>
          <button mat-icon-button (click)="downloadExhibit(element); $event.stopPropagation();"
            title="Download {{ element.name }}" [disabled]="isBusy">
            <mat-icon class="mdi-18px" fontIcon="mdi-download" alt="Download"></mat-icon>
          </button>
          <button mat-icon-button (click)="deleteExhibit(element); $event.stopPropagation()" style="outline: none;"
            title="Delete {{ element.name }}" [disabled]="isBusy || !canEditExhibit(element.id)">
            <mat-icon class="mdi-18px center-self" fontIcon="mdi-trash-can-outline"></mat-icon>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
        <td mat-cell *matCellDef="let element">{{ element.name }}</td>
      </ng-container>

      <ng-container matColumnDef="dateCreated">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Created</th>
        <td mat-cell *matCellDef="let element">{{ element.dateCreated | date: "yyyy-MM-dd HH:mm" }}</td>
      </ng-container>

      <ng-container matColumnDef="createdBy">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>User</th>
        <td mat-cell *matCellDef="let element">{{ getUserName(element.createdBy) }}</td>
      </ng-container>

      <ng-container matColumnDef="currentMove">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Move</th>
        <td mat-cell *matCellDef="let element">{{ element.currentMove }}</td>
      </ng-container>

      <ng-container matColumnDef="currentInject">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Inject</th>
        <td mat-cell *matCellDef="let element">{{ element.currentInject }}</td>
      </ng-container>

      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
          <div [@detailExpand]="element.id === expandedExhibitId ? 'expanded' : 'collapsed'"
            (click)="$event.stopPropagation()">
            @if (element.id === expandedExhibitId) {
            <div class="sub-container">
              <mat-expansion-panel class="bottom-space">
                <mat-expansion-panel-header>
                  <h4>Exhibit Teams</h4>
                </mat-expansion-panel-header>
                <app-admin-teams [exhibitId]="element.id" [canEdit]="canEditExhibit(element.id)"></app-admin-teams>
              </mat-expansion-panel>
              <mat-expansion-panel class="bottom-space">
                <mat-expansion-panel-header>
                  <h4>Card Teams</h4>
                </mat-expansion-panel-header>
                <app-admin-team-cards [teamList]="teamList" [collectionId]="selectedCollectionId"
                  [exhibitId]="element.id" [canEdit]="canEditExhibit(element.id)">
                </app-admin-team-cards>
              </mat-expansion-panel>
              <mat-expansion-panel class="bottom-space">
                <mat-expansion-panel-header>
                  <h4>Article Teams</h4>
                </mat-expansion-panel-header>
                <app-admin-exhibit-articles [exhibit]="element" [teamList]="teamList"
                  [canEdit]="canEditExhibit(element.id)">
                </app-admin-exhibit-articles>
              </mat-expansion-panel>
              <mat-expansion-panel class="bottom-space">
                <mat-expansion-panel-header>
                  <h4>Observers</h4>
                </mat-expansion-panel-header>
                <app-admin-observers [exhibitId]="element.id" [canEdit]="canEditExhibit(element.id)">
                </app-admin-observers>
              </mat-expansion-panel>
              @if (canManageExhibit) {
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <h4>Memberships</h4>
                </mat-expansion-panel-header>
                <app-exhibit-memberships [exhibitId]="expandedExhibitId" [embedded]="false"></app-exhibit-memberships>
              </mat-expansion-panel>
              }
            </div>
            }
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" class="element-row" (click)="toggleExpand(row)"></tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
    </table>
    }
    @if (isLoading) {
    <mat-card appearance="outlined" style="display: flex; justify-content: center; align-items: center;">
      <mat-progress-spinner color="primary" mode="indeterminate">
      </mat-progress-spinner>
    </mat-card>
    }
  </div>
</div>

<input hidden (change)="selectFile($event)" (cancel)="isBusy = false" #jsonInput type="file" accept=".json" />
